export function handleScroll(setFixed) {
    const scrollListener = () => {
        if (window.scrollY > 300) {
            setFixed(true);
        } else {
            setFixed(false);
        }
    };

    window.addEventListener("scroll", scrollListener);

    return () => {
        window.removeEventListener("scroll", scrollListener);
    };
}


export function toggleNav(setNavWidth) {
    setNavWidth((prevWidth) => (prevWidth === "200px" ? "54px" : "200px"));
}
